import { atom, atomFamily } from 'recoil';

/**
 * Atom family for tracking and syncing the size of ui elements.
 */
export const elementSizeAtomFam = atomFamily<
  DOMRectReadOnly | null | undefined,
  string /** keyed by html element id */
>({
  key: 'elementSizeAtomFam',
  default: null,
});

/** Any app can set this to true to toggle the sider panel to open/close.  */
export const atShellToggleSiderOpenCloseAtom = atom<boolean>({
  key: 'atShellToggleSiderOpenCloseAtom',
  default: false,
});

export type ToggleSiderOptions = {
  /** size of the sidepanel, in pixels, when expanded to take up most of the view */
  expandedWidth: number;
  /** size of the sidepanel, in pixels, when collapsed, to occupy a smaller area on the right side of the screen */
  collapsedWidth: number;
  /** the point at which the sidepanel expands vs. collapses when toggled (the specific sizepanel pixel size) */
  threshold: number;
};

interface AtShellPublicMethods {
  /** Toggles sider between occuping a smaller panel on the right-hand side of the screen, and occupying a majorty of the screen space, with the main view
   * occuping a small area on the left. This toggle mechanism currently used by Classification Enrichment tool.
   */
  toggleSider?: (options: ToggleSiderOptions) => void;
  /** Toggles sider between being visible and hidden. The sider will hide itself if its width is greater than 0.
   */
  toggleSiderVisibility?: () => void;
}
/** The sider's open size when toggled open via the UI button. Updated when user manually drags sider.
 * Can be set prior to setting atShellToggleSiderOpenCloseAtom to true, to determine size of sider when it opens.
 */
export const atShellPublicMethodsAtom = atom<AtShellPublicMethods>({
  key: 'atShellPublicMethodsAtom',
  default: {},
});
